
import { defineComponent, PropType } from '@vue/composition-api';
import { LivescoreStatisticsItem } from '../../../../../types/sport';
import IllinoisIcons from '../icons.vue';
import IncidentsCodes from '../../IncidentsCodes.json';

export default defineComponent({
  name: 'CornerRedYellow',
  components: { IllinoisIcons },
  props: {
    statistics: {
      type: Array as PropType<LivescoreStatisticsItem[]>,
      required: true
    },
    sportId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      incidentsCodes: IncidentsCodes
    };
  }
});
